import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Input from "../../input";
import Tooltip from "../../tooltip";
import { useTable } from "../context";
import { isFunction, getTooltipPropsFromCallback } from "../utils";

const RadioSelect = ({ rowData, rowIndex, isScrolling }) => {
  const {
    selectedRow,
    disabledRows,
    uniqueDataKey,
    getSelectionInputTooltip,
    tableId
  } = useTable();
  const rowId = rowData[uniqueDataKey];
  const isChecked = selectedRow === rowId;
  const isDisabled = disabledRows.includes(rowId);

  const tooltip = useMemo(() => {
    if (isFunction(getSelectionInputTooltip)) {
      const tooltipCbResult = getSelectionInputTooltip(rowData, rowIndex);
      return getTooltipPropsFromCallback(tooltipCbResult);
    }

    return null;
  }, [getSelectionInputTooltip, rowData, rowIndex]);

  const input = (
    <Input
      id={`${tableId}-select-radio-${rowId}`}
      name={`${tableId}-select-radio`}
      type="radio"
      checked={isChecked}
      className="row-selection-input"
      disabled={isDisabled}
    />
  );

  /* istanbul ignore else */
  if (tooltip !== null && !isScrolling) {
    return <Tooltip {...tooltip}>{input}</Tooltip>;
  }
  return input;
};

RadioSelect.propTypes = {
  rowData: PropTypes.object,
  isScrolling: PropTypes.bool,
  rowIndex: PropTypes.number
};

export default RadioSelect;
